if (!customElements.get('vbb-set-form')) {
  customElements.define('vbb-set-form', class SetForm extends HTMLElement {
    constructor() {
      super();
      // This has no fallback for when the line item attribute is missing or malformed
      this.setItems = this.querySelectorAll('.vbb-set__details__item');
      this.requiredSetItems = [...this.setItems].filter(item => item.dataset.required === 'true');
      this.variantSelectorItems = this.querySelectorAll('.vbb-set__details__item__info__variants__selector__item');
      this.addSetToCartBtn = this.querySelector('.vbb-set__details__atc button');
      this.cart = document.querySelector('cart-drawer');
      this.setUid = atob(this.id).split('-');
      this.hasVariablePrice = this.dataset.hasVariablePrice === 'true';
      this.currencySymbol = this.dataset.currencySymbol;
      this.minimumItems;
      this.isCustomBundle = this.dataset.customBundle === 'true'
      this.hasItemsOutOfStock = true;
      this.disableAllBundleDiscounts = this.dataset.disableAllBundleDiscounts === 'true'
    }

    setupCartObserver() {
      const observer = new MutationObserver((mutationsList, observer) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList' || mutation.type === 'attributes') {
            this.onCartChange();
          }
        }
      });

      observer.observe(this.cart, { attributes: true, childList: true, subtree: true });
      return observer;
    }

    // observes the active variant attribute on the item - only setup if customBundle
    setupSetObserver() {
      this.setItems.forEach(item => {
        const observer = new MutationObserver((mutationsList, observer) => {
          for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-active-variant-id') {
              this.updateATC();
            }
          }
        });
        observer.observe(item, { attributes: true });
      });
    }

    onCartChange() {
      let disableButton = false;

      if (disableButton) {
        this.addSetToCartBtn.setAttribute('disabled', 'disabled');
      } else if (!disableButton && !this.hasItemsOutOfStock){
        this.addSetToCartBtn.removeAttribute('disabled');
      }
    }

    removeDuplicates() {
      const bundleItem = this.setItems

      const duplicateItems = {}
      // Populate duplicates
      bundleItem.forEach((item) => {
        // Find current variant in cart then add line item id and quantity to duplicates object
        const activeVariantId = item.getAttribute('data-active-variant-id');
        const cartItem = this.cart.querySelector(`[id*="CartDrawer-Item"][data-variant-id="${activeVariantId}"]:not(.hidden):not([data-is-gwp="true"])`)
        if(cartItem){
          duplicateItems[`${cartItem.getAttribute('data-line-item-id')}`] = cartItem.getAttribute('data-quantity') - 1
        }
      });

      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: duplicateItems,
          sections: this.cart.getSectionsToRender().map((section) => section.id)
        })
      })
        .then(response => response.json())
        .then(response => {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'vbb-set-form'
          });

          this.cart.renderContents(response);
        })
        .catch(error => {
          console.error('Error updating cart:', error);
        })
    }

    addSetToCart() {
      this.bundleVariantId = this.dataset.bundleVariantId;
      if(!this.bundleVariantId) {
        console.error('No bundle variant ID found on set form');
        return;
      };
      let validState = false
      if(!this.isCustomBundle){
        validState = true
      }
      else {
        this.setItems = this.querySelectorAll('.vbb-set__details__item[data-active-variant-id]:not([data-active-variant-id=""]')
        validState = (this.setItems.length - this.requiredSetItems.length) >= this.minimumItems
      }
      if (!this.cart.loading && validState) {
        const bundleId = this.uuidv4();

        const setFormConfig = fetchConfig('javascript');
        setFormConfig.headers['x-requested-with'] = 'XMLHttpRequest';
        delete setFormConfig.headers['Content-Type'];

        // Reduce set to variant IDs and quantities
        const setItems = [...this.setItems];
        const set = setItems.reduce((acc, setItem) => {
          const exists = acc[setItem.dataset.activeVariantId];
          acc[setItem.dataset.activeVariantId] = (exists ? (exists + 1) : 1);
          return acc;
        }, {});

        this.setForm = new FormData();

        Object.entries(set).forEach(([variantId, quantity], index) => {
          this.setForm.append(`items[${index}][id]`, variantId);
          this.setForm.append(`items[${index}][quantity]`, quantity);
          this.setForm.append(`items[${index}][properties][_bundleId]`, bundleId);
          this.setForm.append(`items[${index}][properties][_bundleVariantId]`, this.bundleVariantId);

        });

        if (this.setForm.get('sections') && this.setForm.get('sections_url')) {
          this.setForm.set('sections', this.cart.getSectionsToRender().map((section) => section.id));
          this.setForm.set('sections_url', window.location.pathname);
        } else {
          this.setForm.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          this.setForm.append('sections_url', window.location.pathname);
        }

        this.cart.setActiveElement(document.activeElement);

        setFormConfig.body = this.setForm;

        this.cart.open();
        this.cart.setLoading();
        fetch(routes.cart_add_url, setFormConfig)
          .then(response => response.json())
          .then(response => {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'vbb-set-form'
            });

            this.cart.renderContents(response);

            this.sendAddToCartTrackingEvent();
          })
          .catch(e => console.error(e))
          .finally(() => {
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
              this.cart.setNotLoading();
            }
            this.removeDuplicates()
        })
      }
    }

    setHoveredVariantTitle(newVariant, hovering = false) {
      const variantTitleEl = newVariant
        .closest('.vbb-set__details__item__info__variants')
        .querySelector('.vbb-set__details__item__info__variants__active');

      if(!variantTitleEl) return;
      variantTitleEl.innerText = newVariant.dataset.variantTitle;
        this.setMessage(newVariant)
      if (hovering) {
        variantTitleEl.classList.add('vbb-set__details__item__info__variants__active--hovering');
      } else {
        variantTitleEl.classList.remove('vbb-set__details__item__info__variants__active--hovering');
      }
    }

    // Currently does not work if an item is not selected
    restoreSelectedVariantTitle(newVariant) {
      const variantTitleEl = newVariant
        .closest('.vbb-set__details__item__info__variants')
        .querySelector('.vbb-set__details__item__info__variants__active');

        const activeVariant = newVariant
          .closest('.vbb-set__details__item .vbb-set__details__item__info')
          .querySelector('li[data-active="true"]')?.dataset.variantTitle;

        if(variantTitleEl && activeVariant){
          variantTitleEl.innerText = activeVariant;
          variantTitleEl.classList.remove('vbb-set__details__item__info__variants__active--hovering');
        }
      this.setMessage(activeVariant);
    }

    setActiveVariant(newVariant) {
      const setItem = newVariant.closest('.vbb-set__details__item');

      setItem.dataset.activeVariantId = newVariant.dataset.variantId;
      this.setMessage(newVariant);
      setItem.querySelector('.vbb-set__details__item__info__variants__active').classList.remove('vbb-set__details__item__info__variants__active--hovering');

      setItem.querySelectorAll('li').forEach(item => {
        item.dataset.active = (item.dataset.variantId === newVariant.dataset.variantId);
      });

      const newVariantImage = this
        .querySelector('#product-images').content
        .querySelector(`#product-${newVariant.dataset.productId}`)
        .querySelector(`#variant-image-${newVariant.dataset.variantId}`);

      setItem.querySelector('.vbb-set__details__item__image img').src = newVariantImage.src;
      setItem.querySelector(".vbb-set__details__item__image img").srcset =
        newVariantImage.srcset;

      const pricingEl = '.vbb-set__details__item__info__header__pricing';
      const priceHtml = setItem.querySelector(`${pricingEl}--discounted`) ?? setItem.querySelector(`${pricingEl}--prediscounted`);
      priceHtml.innerText = this.toFormattedPrice(
        this.disableAllBundleDiscounts
          ? newVariant.dataset.variantPrice
          : newVariant.dataset.variantDiscountedPrice
      );
      if (setItem.querySelector(`${pricingEl}--prediscounted`)) {
        setItem.querySelector(`${pricingEl}--prediscounted`).innerText = this.toFormattedPrice(newVariant.dataset.variantPrice);
      }

      let newTotalPrice = 0;
      let newDiscountedPrice = 0;
      this.hasItemsOutOfStock = false;
      let disableButton = false;

      this.setItems.forEach(setItem => {
        const setItemActiveVariant = setItem.querySelector('[data-active="true"]:not(variant-selector-modal [data-active="true"])');
        if (setItem.dataset.isProduct === 'true' && setItemActiveVariant) {
          newTotalPrice += parseFloat(setItemActiveVariant.dataset.variantPrice);
          newDiscountedPrice += parseFloat(
            this.disableAllBundleDiscounts
              ? setItemActiveVariant.dataset.variantPrice
              : setItemActiveVariant.dataset.variantDiscountedPrice
          );
          if (setItemActiveVariant.dataset.inStock === 'false' || setItemActiveVariant.dataset.isWaitlisted === 'true') {
            this.hasItemsOutOfStock = true;
          }
        } else {
          newTotalPrice += parseFloat(setItem.dataset.price);
          newDiscountedPrice += parseFloat(
            this.disableAllBundleDiscounts
              ? setItem.dataset.price
              : setItem.dataset.discountedPrice
          );

          if (setItem.dataset.inStock === 'false' || setItem.dataset.isWaitlisted === 'true') {
            this.hasItemsOutOfStock = true;
          }
        }
      });
      if(!this.isCustomBundle){
        if (this.querySelector('.vbb-set__details__price--prediscounted')) {
          this.querySelector('.vbb-set__details__price--prediscounted').innerText = this.toFormattedPrice(newTotalPrice);
        }
        if(this.querySelector('.vbb-set__details__price--discounted')){
          this.querySelector('.vbb-set__details__price--discounted').innerText = this.toFormattedPrice(newDiscountedPrice);
        }
      }
      if (this.hasItemsOutOfStock) {
        this.addSetToCartBtn.innerText = 'Out of Stock';
        this.addSetToCartBtn.setAttribute("disabled", "disabled");
      } else {
        this.addSetToCartBtn.innerHTML = this.createPriceHTML(newTotalPrice, newDiscountedPrice)
        this.addSetToCartBtn.removeAttribute('disabled');
      }

      this.setHoveredVariantTitle(newVariant, false);
    }

    toFormattedPrice(price) {
      return `${this.currencySymbol}${parseFloat(price).toFixed(2)}`;
    }

    uuidv4() {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    }

    createPriceHTML(currentPrice, discountedPrice){
     return  `
      <span class="vbb-set__details__atc--prediscounted-price">${this.toFormattedPrice(currentPrice).replace(',', '.')}</span>
      ${
        this.disableAllBundleDiscounts
          ? ''
          : `<span class="vbb-set__details__atc--discounted-price">${this.toFormattedPrice(discountedPrice).replace(',', '.')}</span>`
      }${
        this.dataset.isUpsell === "true" ?
        `<span> - Complete the Set` :
        `<span> - Add ${this.setItems.length} items to bag</span>`
      }
    `;
    }
    setMessage(swatch) {
      if(!swatch || !(swatch instanceof Node)) return;

      let cartItem;
      const cartMessage = swatch.closest('.vbb-set__details__item').querySelector('.vbb-set__in-cart-message')

      if(swatch.dataset.hasOnlyDefaultVariant === "true" && swatch.dataset.activeVariantId){
        // Products without selector
        cartItem = this.cart.querySelector(`[id*="CartDrawer-Item"][data-variant-id="${swatch.dataset.activeVariantId}"]:not(.hidden):not([data-is-gwp="true"])`) ?? false;
      } else {
        cartItem = this.cart.querySelector(`[id*="CartDrawer-Item"][data-variant-id="${swatch.dataset.variantId}"]:not(.hidden):not([data-is-gwp="true"])`) ?? false;
      }

      if (cartItem) {
        cartMessage.innerText = `You already have ${swatch.dataset.hasOnlyDefaultVariant ? swatch.dataset.productTitle : swatch.dataset.variantTitle} in bag`
        cartMessage.style.display =  "block"
      } else if (!cartItem && cartMessage){
        cartMessage.style.display = "none";
      }
    }

    setupListeners() {
      // set initial message state
      if(!this.isCustomBundle) {
        this.setItems.forEach(item => {
          if (item.dataset.isProduct === 'true' && item.dataset.hasOnlyDefaultVariant === 'false') {
            this.setMessage(item.querySelector('[data-active="true"]'));
          } else {
            const cartItem = this.cart.querySelector(`[id*="CartDrawer-Item"][data-variant-id="${item.dataset.activeVariantId}"]:not(.hidden):not([data-is-gwp="true"])`)
            const cartMessage = item.querySelector(`.vbb-set__in-cart-message`)
            if (cartItem) {
              if (item.dataset.hasOnlyDefaultVariant === 'true') {
                cartMessage.innerText = `You already have this product in your bag`
              } else {
                const itemName = item.querySelector('.vbb-set__details__item__info__variants__active')
                cartMessage.innerText = `You already have ${itemName.innerText} in your bag`
              }
              cartMessage.style.display =  "block"
            } else {
              cartMessage.style.display = "none";
            }
          }
        })
      }
      else {
        this.setItems.forEach(item =>{
          const button = item.querySelector('.vbb-set__details__item--button')
          if(button){
            // is hidden with css when the item has the attribute
            button.addEventListener('click', () => {
              item.dataset.activeVariantId = button.dataset.activeVariantId;
              this.setMessage(item);
            })
          }
          // is shown with css when the item has the attribute
          const removeButton = item.querySelector('.vbb-set__details__item--button__remove')
          if(removeButton){
            removeButton.addEventListener('click', (e) => {
              e.preventDefault()
              item.dataset.activeVariantId = ""
              const activeSwatch = item.querySelector('li[data-active="true"]')
              // check for active swatch and turn it off
              if(activeSwatch) {
                activeSwatch.dataset.active = "false"
              }
            })
          }
        })
      }

      this.variantSelectorItems.forEach(swatch => {
        swatch.addEventListener('mouseover', () => this.setHoveredVariantTitle(swatch, !(swatch.dataset.active === "true")));
        swatch.addEventListener('mouseleave', () => this.restoreSelectedVariantTitle(swatch));
        swatch.addEventListener('click', () => this.setActiveVariant(swatch));
      });
      this.addSetToCartBtn.addEventListener('click', this.addSetToCart.bind(this));
    }

    updateATC(){
      this.setItems = this.querySelectorAll('.vbb-set__details__item[data-active-variant-id]:not([data-active-variant-id=""]')
      if(this.amountToQualify <= 0){
        let currentPrice = 0;
        let currentDiscountPrice = 0;
        let disableButton = false;

        this.setItems.forEach(item => {
          // Finds variant ?? Finds product
          const activeItem = item.querySelector('[data-active="true"]:not(variant-selector-modal [data-active="true"])') ?? item
          currentDiscountPrice += parseFloat(activeItem.dataset.variantDiscountedPrice ?? activeItem.dataset.discountedPrice);
          currentPrice += parseFloat(activeItem.dataset.price ?? activeItem.dataset.price);
          if(!disableButton && (activeItem.dataset.inStock === 'false' || activeItem.dataset.isWaitlisted === 'true')){
            this.hasItemsOutOfStock = true;
            disableButton = true;
          }
        })
        this.addSetToCartBtn.innerHTML = this.createPriceHTML(currentPrice, currentDiscountPrice)
        this.addSetToCartBtn.removeAttribute('disabled');
        if(disableButton){
          this.addSetToCartBtn.innerText = 'Out of Stock';
          this.addSetToCartBtn.setAttribute('disabled', 'disabled');
        }
      } else {
        this.addSetToCartBtn.innerText = `Select at least ${this.amountToQualify} more ${this.amountToQualify > 1 ? 'items' : 'item'}`
        this.addSetToCartBtn.setAttribute('disabled', 'disabled');
      }
    }
    get amountToQualify(){
      return this.minimumItems - (this.setItems.length - this.requiredSetItems.length)
    }

    // Tracking
    sendAddToCartTrackingEvent() {
      if (window.Shopify && window.Shopify.analytics) {
        const trackingData = {
          event: 'add_to_cart',
          ecommerce: {
            currency: this.querySelector('.vbb-set__details__item').dataset.currencyCode,
            items: Array.from(this.querySelectorAll('.vbb-set__details__item')).map((setItem, index) => {
              const hasOnlyDefaultVariantOrIsSingleVariant = (
                setItem.dataset.hasOnlyDefaultVariant === 'true'
                || setItem.dataset.isProduct === 'false'
              );

              let activeVariant = null;

              if (!hasOnlyDefaultVariantOrIsSingleVariant) {
                activeVariant = setItem.querySelector(`li[data-variant-id="${setItem.dataset.activeVariantId}"]`);
              }

              return {
                item_id: hasOnlyDefaultVariantOrIsSingleVariant
                  ? setItem.dataset.sku
                  : activeVariant.dataset.sku,
                item_name: setItem.dataset.productTitle,
                affiliation: 'Victoria Beckham Beauty',
                coupon: this.dataset.setName,
                currency: setItem.dataset.currencyCode,
                discount: hasOnlyDefaultVariantOrIsSingleVariant
                  ? (parseFloat(setItem.dataset.price) - parseFloat(setItem.dataset.discountedPrice))
                  : (parseFloat(activeVariant.dataset.variantPrice) - parseFloat(activeVariant.dataset.variantDiscountedPrice)),
                index,
                item_brand: 'Victoria Beckham Beauty',
                item_variant: (activeVariant != null)
                  ? activeVariant.dataset.variantTitle
                  : setItem.dataset.variantTitle,
                item_price: hasOnlyDefaultVariantOrIsSingleVariant
                  ? parseFloat(setItem.dataset.price)
                  : parseFloat(activeVariant.dataset.variantPrice),
                quantity: 1
              };
            }),
          },
        };
        trackingData.ecommerce.value = trackingData.ecommerce.items.reduce((total, item) => {
          return total + (item.item_price - item.discount);
        }, 0);

        window.Shopify.analytics.publish('custom_product_add_to_cart', trackingData);
      }
    }

    connectedCallback() {
      this.setupListeners();
      if(this.addSetToCartBtn.dataset.hasStockOnLoad == 'false' && !this.customBundle) {
        this.addSetToCartBtn.innerText = 'Out of Stock';
        this.addSetToCartBtn.setAttribute('disabled', 'disabled');
      } else {
        let disableButton = false;
        if(disableButton) {
          this.addSetToCartBtn.setAttribute('disabled', 'disabled');
        }
      }
      if(this.isCustomBundle){
        this.addSetToCartBtn.setAttribute('disabled', 'disabled');
        this.minimumItems = this.addSetToCartBtn.dataset.minimumItems;
        this.setupCartObserver();
        this.setupSetObserver()
      }
    }
  });
}
